module.exports = __webpack_public_path__ + "static/img/UCR_Icon_BluBG.e296041.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UCR_Icon_BluBG.png
// module id = 370
// module chunks = 1